import { makeObservable, observable, action } from 'mobx'

class UserStore {
  isLoaded = false
  bottomsheetOpened = false
  nudgeBannerDismissedAt = null
  userInfo = {}

  constructor() {
    makeObservable(this, {
      isLoaded: observable,
      bottomsheetOpened: observable,
      nudgeBannerDismissedAt: observable,
      userInfo: observable,

      setIsLoaded: action,
      setBottomsheetOpened: action,
      setUserInfo: action,
      setNudgeBannerDismissedAt: action,
    })
  }

  setIsLoaded(isLoaded) {
    this.isLoaded = isLoaded
  }

  setBottomsheetOpened(bottomsheetOpened) {
    this.bottomsheetOpened = bottomsheetOpened
  }

  setUserInfo(userInfo) {
    this.userInfo = userInfo
  }

  setNudgeBannerDismissedAt(nudgeBannerDismissedAt) {
    this.nudgeBannerDismissedAt = nudgeBannerDismissedAt
  }

  set(key, value) {
    function setProperty(obj, keys, val) {
      let key
      while (keys.length > 1) {
        key = keys.shift()
        if (!obj.hasOwnProperty(key)) obj[key] = {}
        obj = obj[key]
      }
      obj[keys[0]] = val
    }

    if (key?.includes('.')) {
      const keys = key.split('.')
      setProperty(this, keys, value)
    } else {
      this[key] = value
    }
  }
}

const container = {}
container.instance = new UserStore()
export default container.instance
